<template>
    <v-file-input
        class="mx-4"
        :clearable="false"
        show-size
        multiple
        accept=".zip,.7z"
        :label="fileinputlabel"
        v-bind:value="value"
        v-on:change="$emit('input', $event)"
        >
        <template v-slot:selection="{ index, text }">
            <v-chip
                close
                @click:close="deleteChip(index)"
            >
            {{ text }}
            </v-chip>
        </template>
    </v-file-input>
</template>

<script>
export default {
    name: 'CloseableChipFileInput',
    props: ['fileinputlabel','value'],
    data: () => ({ 
    }),
    methods: {
        deleteChip(index) {
            this.value.splice(index, 1)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/customwidgets/CloseableChipFileInput.vue